import Loadable from 'react-loadable'

const LOADABLE_CONFIG = { loading: () => null, delay: 500 }
export const Pages = {
    mobiledemo: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MobileDemoPage'),
    }),
    mobileRegister: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbRegisterPage'),
    }),
    mobileForgotPassword: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbForgotPasswordPage'),
    }),
    mobileForgotEmail: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbForgotEmailPage'),
    }),
    mobileAsiaContactUs: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbAsiaContactUsPage'),
    }),
    mobileAsiaQRCode: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbAsiaQRCodePage'),
    }),
    mobileBlockPage: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbBlockPage'),
    }),
    mobileNotSupported: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbNotSupportedPage'),
    }),
    mobileActiveLink: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../../pages/MbActiveLinkPage'),
    })
  }


// WEBPACK FOOTER //
// ./src/app/common/config/LinkRoutes.js